<template>
  <div>
    <div class="error" v-if="apiData.error" />
    <div class="not-found" v-if="apiData.notFound" />
    <custom-doughnut-chart-wrapper v-else-if="total" :title="title" :total="total" :apiData="apiData" />
    <div class="skeleton" v-else />
  </div>
</template>

<script>
import CustomDoughnutChartWrapper from '@/components/CustomDoughnutChartWrapper'

export default {
  name: 'Doughnut',
  components: {
    CustomDoughnutChartWrapper,
  },
  props: {
    title: String,
    apiData: Object,
  },
  computed: {
    total: function () {
      // eslint-disable-next-line no-unused-vars
      return this.apiData.total || Object.entries(this.apiData).reduce((acc, [key, value]) => acc + value, 0)
    },
  },
}
</script>

<style lang="sass" scoped>
.error,
.not-found,
.skeleton
  display: flex
  width: 160px
  height: 160px
  margin: 20px
  margin-top: 40px
  border-radius: 50%

.error
  background-color: brown

.not-found
  background-color: blue

.skeleton
  animation: shine 1.6s infinite linear
  background-image: linear-gradient(90deg, #cecece 20px, #d6d6d6 50px, #cecece 80px)
  background-size: 300px

@keyframes shine
  0%
    background-position: -80px
  40%, 100%
    background-position: 150px
</style>
